import { ReactNode } from 'react'
import cn from 'utils/cn'

const AlertBadge = ({
  children,
  className
}: {
  children: ReactNode
  className?: string
}) => {
  return (
    <span
      className={cn([
        'text-white bg-danger uppercase rounded-full px-2 text-center text-sm',
        className
      ])}
    >
      {children}
    </span>
  )
}

export default AlertBadge
